import { memo } from 'react'
import { createUseStyles } from 'react-jss'
import HTMLParse from 'react-html-parser'
import classNames from 'classnames'
import InViewTrigger from '@/components/InViewTrigger'
import BtnLink from '@/components/BtnLink'
import RevealFadeIn from '@/components/RevealFadeIn'
import { removeParagraph } from '@/utils/strings'
import style from './style'

const useStyles = createUseStyles(style)

const Chi = ({
  className,
  title,
  text,
  list,
}) => {
  const classes = useStyles()

  /*------------------------------
  Render List
  ------------------------------*/
  const renderList = () => {
    return list.length > 0 && (
      <div className={classes.list}>
        {list.map((item, index) => (
          <div className={classes.item} key={index.toString()}>
            <div className={classes.img}>
              <svg xmlns="http://www.w3.org/2000/svg" width="54" height="90" viewBox="0 0 54 90">
                <defs>
                  <linearGradient id="gradient3" x2="1" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stopColor="#efefef" />
                    <stop offset="1" stopColor="#fff" />
                  </linearGradient>
                </defs>
                <path id="Unione_2" data-name="Unione 2" d="M-2334,664a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2334,664Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2346,664Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2358,664Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2370,664Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2382,664Zm48-12a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2334,652Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2346,652Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2358,652Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2370,652Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2382,652Zm48-12a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2334,640Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2346,640Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2358,640Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2370,640Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2382,640Zm48-12a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2334,628Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2346,628Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2358,628Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2370,628Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2382,628Zm48-12a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2334,616Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2346,616Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2358,616Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2370,616Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2382,616Zm48-12a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2334,604Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2346,604Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2358,604Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2370,604Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2382,604Zm48-12a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2334,592Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2346,592Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2358,592Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2370,592Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2382,592Zm48-12a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2334,580Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2346,580Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2358,580Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2370,580Zm-12,0a3,3,0,0,1,3-3,3,3,0,0,1,3,3,3,3,0,0,1-3,3A3,3,0,0,1-2382,580Z" transform="translate(2382 -577)" fill="url(#gradient3)" />
              </svg>

              <img alt={item.title} src={item.image?.url} data-scroll data-scroll-speed={0.2} />
            </div>
            <div className={classes.itemTitle}>
              {HTMLParse(removeParagraph(item.title))}
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <InViewTrigger className={classNames({
      [classes.root]: true,
      [className]: className,
    })}
    >
      <RevealFadeIn>
        <div className={classes.intro}>
          <div className={classes.pretitle}>
            <BtnLink
              label={title}
            />
          </div>
          <div className={classes.text}>
            {HTMLParse(text)}
          </div>
        </div>
        {renderList()}
      </RevealFadeIn>
    </InViewTrigger>
  )
}

export default memo(Chi)
